import styled from "styled-components";
import { Box, Cluster, Stack, ButtonWithLink, util } from "@thecb/components";

const { adjustHexColor } = util.general;

export const BannerContainer = styled(Cluster)`
  background: ${({ themeValues }) =>
    adjustHexColor(themeValues.primaryColor, 90, "lighten")};
  padding: 2rem;
`;

export const ContentContainer = styled(Cluster)`
  padding: 0;
  width: ${({ isMobile }) => (isMobile ? "100%" : " 1224px")};
  > div {
    flex-direction: ${({ isMobile }) => (isMobile ? "column" : "row")};
  }
`;

export const ButtonContainer = styled(Stack)`
  align-items: center;
  width: ${({ isMobile }) => (isMobile ? "100%" : "222px")};
  padding-left: ${({ isMobile }) => (isMobile ? "0" : "2rem")};
  > * {
    width: inherit;
  }
`;

export const RegisterLink = styled(ButtonWithLink)`
  border-radius: 100px;
  margin: 0;
  width: 100%;
`;

export const LoginLink = styled(ButtonWithLink)`
  border-radius: 100px;
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 2rem;
  margin-top: 0px;
  border: none;
  &:hover {
    text-decoration: none;
  }
`;
